import { device } from 'constants/device';

import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.system.white};
  display: flex;
  padding: 24px;
  border: 1px solid ${({ theme }) => theme.system.lightGrey};
  border-radius: 20px;
  width: 100%;
  height: 112px;
  position: relative;
  &:hover {
    border: 1px solid ${({ theme }) => theme.brand.blue};
  }
  @media ${device.tablet} {
    height: 88px;
    padding: 12px;
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 24px 0;
  height: 100%;
  width: 100%;
  @media ${device.tablet} {
    margin: 0;
  }
`;

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const GroupContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  height: 100%;
`;

export const Categories = styled.span`
  padding-right: 6px;
  border-right: 2px solid #a3a1a1;
  font-weight: 600;
  font-size: 1.4rem;
  line-height: 140%;
  color: ${({ theme }) => theme.system.darkGreyActive};
  @media ${device.tablet} {
    font-size: 1rem;
    border-width: 1px;
  }
`;

export const EducationType = styled.span`
  padding-left: 6px;
  font-weight: 600;
  font-size: 1.4rem;
  line-height: 140%;
  color: ${({ theme }) => theme.system.darkGreyActive};
  @media ${device.tablet} {
    font-size: 1rem;
  }
`;

export const Courses = styled.span`
  font-weight: 500;
  font-size: 1.4rem;
  line-height: 140%;
  color: ${({ theme }) => theme.system.black};
  text-overflow: ellipsis;
  overflow: hidden;
  @media ${device.tablet} {
    font-size: 1rem;
  }
`;

export const TitleWrapper = styled.div`
  & > span {
    font-weight: bold;
    font-size: 14px;
    line-height: 140%;
  }
`;
